import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const api = process.env.REACT_APP_API_URL;

// Stable identity while keywords load, a fresh [] per render would retrigger
// every downstream memo/effect and loop the overlay's onStats -> setState cycle.
const EMPTY = [];

/**
 * Fetch the JD must-have keywords for the gaze overlay (matching + the missing
 * slice the caller is entitled to; the backend enforces the paywall on the
 * missing list). Fetches once, when `active` first becomes true.
 *
 * The fetch must NOT be cancelled by the effect's own state updates (the
 * classic loading-in-deps cleanup trap), so the only dependency is `active`
 * and a ref guards against double-fetching.
 */
export default function useGazeKeywords(active) {
  const [keywords, setKeywords] = useState(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!active || startedRef.current) return;
    startedRef.current = true;
    axios
      .get(`${api}gaze-keywords/`, { withCredentials: true })
      .then(res => {
        const matching = Array.isArray(res.data.matching_keywords) ? res.data.matching_keywords : [];
        const missing = Array.isArray(res.data.missing_keywords) ? res.data.missing_keywords : [];
        setKeywords([...matching, ...missing]);
      })
      .catch(() => setKeywords(EMPTY));
  }, [active]);

  return { keywords: keywords || EMPTY, loading: active && keywords === null };
}
